function questionSetDirective() {
    'ngInject';

    return {
        transclude: false,
        restrict: 'A',
        scope: true,
        link(scope, element, attrs) {
            const set = attrs.bbQuestionSet;
            element.addClass('ng-hide');
            scope.$watch(set, (newval, oldval) => {
                if (newval) {
                    scope.question_set = newval;
                    element.removeClass('ng-hide');
                }
            });
        }
    };
}

angular
    .module('BB.inputs')
    .directive('bbQuestionSet', questionSetDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-inputs/question-set/question_set.directive.js